import report from "./report";



export default {report};
